import React from 'react'
import './baniere.css'
import Slider from "react-slick"
export const  Baniere = () => {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1, 
            }
        }]
        /*appendDots: (dots) => {
          return <ul style={{margin: "0px"}}>{dots}</ul>
        }*/
      }
    return (
        <>
           <section className='baniere'>
                <div className="row">
                    <div className="column">
                        <img src="1.jpg" alt="Snow"/>
                        <div className="centered">EXPEDITION DE FRET</div>
                    </div>
                    <div className="column">
                        <img src="3.jpg" alt="Forest"/>
                        <div className="top-right">AU SERVICE DE L'EFFICACITE <br/> 
                        ET DE LA RENTABILITE</div>
                    </div>
                    <div className="column">
                        <img src="2.jpg" alt="Mountains"/>
                    </div>
                    <div className="column">
                        <img src="4.jpg" alt="Mountains"/>
                    </div>
                </div>
            </section>
            <section className='slid'>
            <Slider { ...settings}>
            <div>
            <img src="1.jpg" alt="Forest"/>
            <span className="centered">EXPEDITION DE FRET</span>
          </div>
          <div>
          <img src="3.jpg" alt="Forest"/>
          </div>
          <div>
          <img src="2.jpg" alt="Mountains"/>
          <span className="top-right">AU SERVICE DE L'EFFICACITE <br/> 
                        ET DE LA RENTABILITE</span>
          </div>
          <div>
          <img src="4.jpg" alt="Mountains"/>
          </div>
            </Slider>
            </section>
        </>
    )
  }